<template>
  <div>
    <validation-observer
      ref="cateLabelForm"
      tag="form"
      @submit.prevent="submitForm()">
      <v-row>
        <v-col
          cols="12">
          <text-field-form
            v-model.trim="formData.name"
            outlined
            :rules="formRules.name"
            name="Name"
            out-field-label="Name"
            placeholder="Name" />
        </v-col>
        <v-col
          cols="12">
          <file-input-form
            v-model="formData.imageUrl"
            :multiple="false"
            need-compress
            class="material-drop-file"
            s3-path="/care-labels"
            caption="คลิกเพื่อเพิ่มรูปภาพ"
            label-bold
            outlined
            append-icon="mdi-camera"
            :upload="{ accept: 'image/*' }"
            prepend-icon=""
            out-field-label="Image"
            placeholder="Image"
            name="Image"
            :rules="{ required: true }"
          />
        </v-col>
        <v-col cols="12">
          <v-btn
            class="mr-4"
            :disabled="loading"
            color="secondary"
            outlined
            @click="onCancel">
            CANCEL
          </v-btn>
          <v-btn
            :disabled="loading"
            color="secondary"
            type="submit">
            SUBMIT
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </div>
</template>
<script>
  export default {
      props: {
          value: {
            type: Object,
            default: null
          },
          mode: {
              type: String,
              default: 'create'
          },
          statusList: {
              type: Array,
              default: () => []
          },
          warehouse: {
            type: Array,
            default: () => []
          },
          loading: {
            type: Boolean,
            default: false
          }
      },
      data () {
          return {
              formData: {
                  name: '',
                  imageUrl: ''
              },
              formRules: {
                name: { required: true },
                imageUrl: { required: true }
              }
          }
      },
      mounted () {
        if (this.mode === 'edit' && this.value) {
          this.formData = {
            name: this.value.name || '',
            imageUrl: this.value.imageUrl || ''
          }
        }
      },
      methods: {
          async submitForm () {
              const valid = await this.$refs.cateLabelForm.validate()
              if (valid) {
                  this.$emit('onSubmit', this.formData)
              }
          },
          async onCancel () {
            this.$emit('onCancel')
          }
      }
  }
  </script>

  <style scoped>
  </style>
